import ProTeacherLsmDetail from '../../features/proteacher/ProTeacherLsmDetail'

const ProTeacherLsmDetailPage = () => {
  return (
   <ProTeacherLsmDetail/>
  )
}

export default ProTeacherLsmDetailPage
